<template>
    <Sheet class="container">
        <span class="warning hidden-sm-and-down">WARNING!</span>
        <span class="warning sm hidden-md-and-up">WARNING!</span>
        <h1>403</h1>
        <h3>您的權限不足!!</h3>
    </Sheet>
</template>

<script>
export default {
  name: 'Forbidden'
}
</script>

<style scoped>
    .container{
        text-align: center;
    }
    .container .warning{
        font-size: 4rem;
        font-weight: bolder;
        color: orange;
    }
    .container .warning.sm{
        font-size: 2rem;
    }
</style>
